import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { apiGetProffitSearchGroup } from '../../../../actions/ProffitSearchGroupAction';
import { useDidMount } from '../../../../helpers/use/useHook';
import { AllLoaderComponent } from '../../../Ui/Loading';
const ProffitSearchGroupHoc = () => (ChildComponent) => {
    const ProffitSearchGroupHocInner = (props) => {
        const dispatch = useDispatch();
        const proffitSearchGroup = useSelector((state) => state.proffitSearchGroup);
        useDidMount(() => {
            dispatch(apiGetProffitSearchGroup());
        });
        if (!proffitSearchGroup.group) {
            return _jsx(AllLoaderComponent, {});
        }
        return _jsx(ChildComponent, Object.assign({}, props, { group: proffitSearchGroup.group }));
    };
    ProffitSearchGroupHocInner.propTypes = {};
    return ProffitSearchGroupHocInner;
};
export default ProffitSearchGroupHoc;
